<template>
  <section :class="sectionClass" v-if="item.modulinfotext1spaltigueberschrift">
    <div class="container">
      <h2 class="section-title info-1c-text__title">
        <span class="headline" v-html="item.modulinfotext1spaltigueberschrift"></span>
      </h2>
      <div class="info-1c-text__text" v-html="item.modulinfotext1spaltigtext"></div>

      <div class="center" v-if="item.modulinfotext1spaltigbutton.url">
        <a
          :href="item.modulinfotext1spaltigbutton.url"
          :target="item.modulinfotext1spaltigbutton.target"
          class="button button--cat1 button--large"
          v-html="item.modulinfotext1spaltigbutton.text"
        >
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulInfoText1Spaltig',
  data() {
    return {
      item: this.context.item,
    };
  },
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    sectionClass: function () {
      if (this.item.modulinfotext1spaltigstyle != '')
        return 'outer info-1c-text section-styling-' + this.item.modulinfotext1spaltigstyle;
      return 'outer info-1c-text section-styling-0';
    },
  },
};
</script>
